import { AppState } from 'store/root.reducer'

export const selectFileState = (state: AppState) => state?.file

export const selectUpdateFileDataStatuses = (state: AppState) => selectFileState(state)?.updateFileDataStatuses

export const selectSetFileDeletionStatuses = (state: AppState) => selectFileState(state)?.setFileDeletionStatuses
